module.exports = __webpack_public_path__ + "img/facebook-marketing.d95528b.jpg";